module.exports = __webpack_public_path__ + "04fce4b445c7ce0153d8064d9e947c28.svg";